import React, { useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import { useParams, useHistory } from "react-router-dom";
import { useProduct } from "../../hooks";
import { ListProducts } from "../../components/Client";
import { CartButton } from "../../components/Admin";

export function TableMenuProducts() {
  const { id, idCategory } = useParams();
  const { loading, products, getProductsByCategory } = useProduct();
  const history = useHistory();

  useEffect(() => {
    getProductsByCategory(idCategory, true);
  }, [idCategory]);

  const goToMenu = () => history.push(`/admin/table/${id}/menu`);
  const goToCart = () => history.push(`/admin/table/${id}/menu/cart`);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button icon labelPosition="left" onClick={goToMenu}>
          <Icon name="arrow left" />
          Regresar al Menu
        </Button>
        <CartButton onClick={goToCart} />
      </div>

      {loading ? <p>Cargando...</p> : <ListProducts products={products} />}
    </div>
  );
}
